import { useEffect, createContext, useContext } from "react";
import { onEscKey, onTabKey, onDeleteKey } from "lib/helpers";
import { rootNamespace } from "config";
import useTree from "lib/tree";
import { useParams } from "react-router-dom";
import Windows from "./Windows";
import Sidebar from "./Sidebar";
import { defaultLayout } from "windows";
import _ from "lodash";
import { ProjectsContext } from "App";

export const TreeContext = createContext();

function Head() {
  return (
    <div className="hd">
      <div className="hdl">
        <button>
          <i className="fa fa-bars" />
        </button>
      </div>
      <div className="hdr">
        <button className="h">
          <i className="fa fa-cloud-upload-alt" />
        </button>
        <button>
          <span className="p" />
        </button>
      </div>
    </div>
  );
}

export function EditorContent({ treeData = {}, projectId }) {
  const treeApi = useTree(treeData, projectId);
  const { selection, tree } = treeApi;
  useEffect(() => {
    const listener = (e) => {
      onEscKey(() => treeApi.publish(rootNamespace, "ESC"))(e);
      onTabKey(() => treeApi.publish(rootNamespace, "TAB", e))(e);
      onDeleteKey(() => {
        if (e.target === document.body && selection)
          treeApi.publish(rootNamespace, "REMOVE", selection.path);
      })(e);
    };
    window.addEventListener("keydown", listener);
    return () => window.removeEventListener("keydown", listener);
  }, [selection, treeApi]);
  useEffect(() => {
    if (tree.onLoad) {
      // eslint-disable-next-line no-new-func
      const onLoad = new Function("return " + tree.onLoad);
      const unsubscribe = [];
      const pubsub = {
        subscribe: (namespace, topic, data) => {
          unsubscribe.push(treeApi.subscribe(namespace, topic, data));
        },
      };
      onLoad()(pubsub);
      return () => unsubscribe.forEach((callback) => callback());
    }
  }, [tree.onLoad, treeApi]);
  return (
    <TreeContext.Provider value={treeApi}>
      <div className="fc">
        <Head />
        <div className="ec">
          <Sidebar />
          <Windows layout={defaultLayout} />
        </div>
      </div>
    </TreeContext.Provider>
  );
}

export default function EditorPage() {
  let { id } = useParams();
  const { projects, busy } = useContext(ProjectsContext);
  if (busy) return null;
  if (id) {
    id = parseInt(id, 10);
    const project = _.find(projects, ["id", id]);
    const treeData = project.data ? JSON.parse(project.data) : {};
    return <EditorContent projectId={id} treeData={treeData} />;
  } else {
    return <EditorContent />;
  }
}
